var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2"},[_c('p',{staticClass:"text-sm-center text-secondary"},[_vm._v(_vm._s(_vm.title))]),_c('hr',{staticClass:"w-100 m-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }